// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.authCommonCard_authCommonSection__K2X7W {
  width: 100%;
  background: var(--gradient-1);
  flex: 1 1;
  min-height: calc(100dvh - 72px);
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
}
.authCommonCard_authCommonSection__K2X7W .authCommonCard_inner__\\+IMIe {
  max-width: 960px;
  width: 100%;
  margin: 0 auto;
  box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.1607843137);
  border-radius: var(--border-radius-large);
  background-color: #faf4f2;
  overflow: hidden;
  position: relative;
  z-index: 1;
}
.authCommonCard_authCommonSection__K2X7W .authCommonCard_inner__\\+IMIe .authCommonCard_bgImg__XPkJd {
  position: absolute;
  bottom: -90px;
  right: -70px;
  width: 310px;
  height: 307px;
  z-index: -1;
  opacity: 0.5;
}
.authCommonCard_authCommonSection__K2X7W .authCommonCard_inner__\\+IMIe .authCommonCard_bgImg__XPkJd img {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}
.authCommonCard_authCommonSection__K2X7W .authCommonCard_imageContainer__DJjP2 {
  padding: 30px 45px;
  background-color: rgba(255, 255, 255, 0.3019607843);
  height: 100%;
}
.authCommonCard_authCommonSection__K2X7W .authCommonCard_imageContainer__DJjP2 img {
  width: 100%;
  border-radius: 8px;
  object-fit: cover;
  object-position: top;
  height: 100%;
  min-height: 540px;
}
.authCommonCard_authCommonSection__K2X7W .authCommonCard_formContainer__5tbxZ {
  padding: 20px 52px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.authCommonCard_authCommonSection__K2X7W .authCommonCard_formContainer__5tbxZ .authCommonCard_titleContainer__M6DFG {
  text-align: center;
  margin: 0 0 20px 0;
}
.authCommonCard_authCommonSection__K2X7W .authCommonCard_formContainer__5tbxZ .authCommonCard_titleContainer__M6DFG h4 {
  font: normal 700 32px/48px var(--font-bodoni);
  color: #313131;
  margin-bottom: 8px;
  text-transform: capitalize;
}
.authCommonCard_authCommonSection__K2X7W .authCommonCard_formContainer__5tbxZ .authCommonCard_titleContainer__M6DFG p {
  font: var(--body-font-two);
  color: #8692a4;
}
.authCommonCard_authCommonSection__K2X7W .authCommonCard_formContainer__5tbxZ .authCommonCard_titleContainer__M6DFG p a {
  color: var(--brand);
  margin-left: 2px;
}
.authCommonCard_authCommonSection__K2X7W .authCommonCard_formContainer__5tbxZ .authCommonCard_titleContainer__M6DFG p a:hover {
  text-decoration: underline;
}

@media (max-width: 1170px) {
  .authCommonCard_authCommonSection__K2X7W {
    min-height: calc(100dvh - 69px);
  }
  .authCommonCard_authCommonSection__K2X7W .authCommonCard_inner__\\+IMIe .authCommonCard_bgImg__XPkJd {
    bottom: -100px;
    width: 270px;
  }
  .authCommonCard_authCommonSection__K2X7W .authCommonCard_imageContainer__DJjP2 img {
    max-height: unset;
    min-height: unset;
  }
}
@media (max-width: 991px) {
  .authCommonCard_authCommonSection__K2X7W {
    min-height: calc(100dvh - 72px);
  }
  .authCommonCard_authCommonSection__K2X7W .authCommonCard_imageContainer__DJjP2 {
    padding: 20px 30px;
  }
  .authCommonCard_authCommonSection__K2X7W .authCommonCard_formContainer__5tbxZ {
    padding: 20px 30px;
  }
  .authCommonCard_authCommonSection__K2X7W .authCommonCard_formContainer__5tbxZ .authCommonCard_titleContainer__M6DFG h4 {
    font-size: 26px;
  }
}
@media (max-width: 767px) {
  .authCommonCard_authCommonSection__K2X7W .authCommonCard_imageContainer__DJjP2 {
    padding: 20px 15px;
  }
  .authCommonCard_authCommonSection__K2X7W .authCommonCard_formContainer__5tbxZ {
    padding: 20px 15px;
  }
  .authCommonCard_authCommonSection__K2X7W .authCommonCard_formContainer__5tbxZ .authCommonCard_titleContainer__M6DFG h4 {
    font-size: 22px;
    margin-bottom: 5px;
  }
}
@media (max-width: 599px) {
  .authCommonCard_authCommonSection__K2X7W {
    min-height: calc(100dvh - 66px);
  }
  .authCommonCard_authCommonSection__K2X7W .authCommonCard_inner__\\+IMIe .authCommonCard_bgImg__XPkJd {
    display: none;
  }
  .authCommonCard_authCommonSection__K2X7W .authCommonCard_imageContainer__DJjP2 {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/authCommonCard.module.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,6BAAA;EACA,SAAA;EACA,+BAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACD;AACC;EACC,gBAAA;EACA,WAAA;EACA,cAAA;EACA,wDAAA;EACA,yCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AACF;AACE;EACC,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AACH;AACG;EACC,WAAA;EACA,YAAA;EACA,sBAAA;AACJ;AAIC;EACC,kBAAA;EACA,mDAAA;EACA,YAAA;AAFF;AAIE;EACC,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,iBAAA;AAFH;AAOC;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AALF;AAOE;EACC,kBAAA;EACA,kBAAA;AALH;AAOG;EACC,6CAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;AALJ;AAQG;EACC,0BAAA;EACA,cAAA;AANJ;AAQI;EACC,mBAAA;EACA,gBAAA;AANL;AAQK;EACC,0BAAA;AANN;;AAcA;EACC;IACC,+BAAA;EAXA;EAcC;IACC,cAAA;IACA,YAAA;EAZF;EAiBC;IACC,iBAAA;IACA,iBAAA;EAfF;AACF;AAoBA;EACC;IACC,+BAAA;EAlBA;EAoBA;IACC,kBAAA;EAlBD;EAqBA;IACC,kBAAA;EAnBD;EAsBE;IACC,eAAA;EApBH;AACF;AA0BA;EAEE;IACC,kBAAA;EAzBD;EA4BA;IACC,kBAAA;EA1BD;EA6BE;IACC,eAAA;IACA,kBAAA;EA3BH;AACF;AAiCA;EACC;IACC,+BAAA;EA/BA;EAkCC;IACC,aAAA;EAhCF;EAoCA;IACC,aAAA;EAlCD;AACF","sourcesContent":[".authCommonSection {\r\n\twidth: 100%;\r\n\tbackground: var(--gradient-1);\r\n\tflex: 1;\r\n\tmin-height: calc(100dvh - 72px);\r\n\theight: 100dvh;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tpadding: 20px 0;\r\n\r\n\t.inner {\r\n\t\tmax-width: 960px;\r\n\t\twidth: 100%;\r\n\t\tmargin: 0 auto;\r\n\t\tbox-shadow: 0px 0px 32px 0px #00000029;\r\n\t\tborder-radius: var(--border-radius-large);\r\n\t\tbackground-color: #faf4f2;\r\n\t\toverflow: hidden;\r\n\t\tposition: relative;\r\n\t\tz-index: 1;\r\n\r\n\t\t.bgImg {\r\n\t\t\tposition: absolute;\r\n\t\t\tbottom: -90px;\r\n\t\t\tright: -70px;\r\n\t\t\twidth: 310px;\r\n\t\t\theight: 307px;\r\n\t\t\tz-index: -1;\r\n\t\t\topacity: 0.5;\r\n\r\n\t\t\timg {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 100%;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.imageContainer {\r\n\t\tpadding: 30px 45px;\r\n\t\tbackground-color: #ffffff4d;\r\n\t\theight: 100%;\r\n\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t\tborder-radius: 8px;\r\n\t\t\tobject-fit: cover;\r\n\t\t\tobject-position: top;\r\n\t\t\theight: 100%;\r\n\t\t\tmin-height: 540px;\r\n\t\t\t// max-height: 540px;\r\n\t\t}\r\n\t}\r\n\r\n\t.formContainer {\r\n\t\tpadding: 20px 52px;\r\n\t\theight: 100%;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tjustify-content: center;\r\n\t\tposition: relative;\r\n\r\n\t\t.titleContainer {\r\n\t\t\ttext-align: center;\r\n\t\t\tmargin: 0 0 20px 0;\r\n\r\n\t\t\th4 {\r\n\t\t\t\tfont: normal 700 32px/48px var(--font-bodoni);\r\n\t\t\t\tcolor: #313131;\r\n\t\t\t\tmargin-bottom: 8px;\r\n\t\t\t\ttext-transform: capitalize;\r\n\t\t\t}\r\n\r\n\t\t\tp {\r\n\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\tcolor: #8692a4;\r\n\r\n\t\t\t\ta {\r\n\t\t\t\t\tcolor: var(--brand);\r\n\t\t\t\t\tmargin-left: 2px;\r\n\r\n\t\t\t\t\t&:hover {\r\n\t\t\t\t\t\ttext-decoration: underline;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 1170px) {\r\n\t.authCommonSection {\r\n\t\tmin-height: calc(100dvh - 69px);\r\n\r\n\t\t.inner {\r\n\t\t\t.bgImg {\r\n\t\t\t\tbottom: -100px;\r\n\t\t\t\twidth: 270px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.imageContainer {\r\n\t\t\timg {\r\n\t\t\t\tmax-height: unset;\r\n\t\t\t\tmin-height: unset;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 991px) {\r\n\t.authCommonSection {\r\n\t\tmin-height: calc(100dvh - 72px);\r\n\r\n\t\t.imageContainer {\r\n\t\t\tpadding: 20px 30px;\r\n\t\t}\r\n\r\n\t\t.formContainer {\r\n\t\t\tpadding: 20px 30px;\r\n\r\n\t\t\t.titleContainer {\r\n\t\t\t\th4 {\r\n\t\t\t\t\tfont-size: 26px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.authCommonSection {\r\n\t\t.imageContainer {\r\n\t\t\tpadding: 20px 15px;\r\n\t\t}\r\n\r\n\t\t.formContainer {\r\n\t\t\tpadding: 20px 15px;\r\n\r\n\t\t\t.titleContainer {\r\n\t\t\t\th4 {\r\n\t\t\t\t\tfont-size: 22px;\r\n\t\t\t\t\tmargin-bottom: 5px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 599px) {\r\n\t.authCommonSection {\r\n\t\tmin-height: calc(100dvh - 66px);\r\n\r\n\t\t.inner {\r\n\t\t\t.bgImg {\r\n\t\t\t\tdisplay: none;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.imageContainer {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"authCommonSection": `authCommonCard_authCommonSection__K2X7W`,
	"inner": `authCommonCard_inner__+IMIe`,
	"bgImg": `authCommonCard_bgImg__XPkJd`,
	"imageContainer": `authCommonCard_imageContainer__DJjP2`,
	"formContainer": `authCommonCard_formContainer__5tbxZ`,
	"titleContainer": `authCommonCard_titleContainer__M6DFG`
};
export default ___CSS_LOADER_EXPORT___;
